import(/* webpackMode: "eager" */ "/vercel/path0/apps/connect/src/app/error.tsx");
